<template>
  <a-modal name="InviteLink-modal">

    <div
      class="invite-link"
      @click.self="closeModal"
    >
      <svg
        class="invite-link-background"
        width="1597"
        height="431"
        viewBox="0 0 1597 431"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="-3" width="1600" height="431" fill="#6367A7"/>
      </svg>
      <div class="invite-modal">
        <h2 class="invite-modal__title">
          {{result.messages.title}}
        </h2>
        <AInput
            :label="' '"
            :staticLabel="true"
            v-model="link" :readonly="true"/>
        <p class="invite-modal__text">{{result.messages.subUrlInfo}}</p>
        <div class="invite-modal-buttons">
          <ABtn v-for="btn in result.buttons"
                :label="btn.title"
                @click.prevent="clickEvent(btn)"
                :bg="btn.type=='copy'?'#00A59E':'#fff'"
                :color="btn.type=='copy'?'':'#00A59E'"
                :class="btn.type=='copy'?'':'invite-modal-buttons__reset'"
          />
        </div>
        <h5 class="partner-list-title">{{result.messages.afterTextTitle}}</h5>
        <PartnerList>
          <li v-for="text in result.messages.afterTextItems">
            <span v-html="text"></span>
          </li>
        </PartnerList>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {AModal, useAModal, AInput, ABtn} from '../../ui';
import {ref} from "vue";

export default {
  name: 'InviteLink',
  props: ['result'],
  components: {
    AModal,
    AInput,
    ABtn,
  },
  setup(props) {
    const modal = useAModal();
    const link = ref(props.result.link);
    const closeModal = () => {
      modal.hide();
    }
    const clickEvent = (btn) => {
      if(btn.type=='copy') {
        navigator.clipboard.writeText(link.value).then(() => {
          showNotification('success',props.result.messages.linkCopiedSuccess,'');
        }).catch(err => {
          showNotification('danger',props.result.messages.linkCopiedFailure,'');
        });
      }
      modal.hide();
    }
    return {
      closeModal,
      clickEvent,
      link
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-link {
  min-height: 100vh;
  background-color: #fff;
}
.invite-link-background{
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}
.invite-modal{
  position: absolute;
  max-width: 684px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 45px 64px 60px 57px;
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
    margin: 0 0 36px;
  }
  &__text{
    font-size: 12px;
    line-height: 16px;
    color: #68737D;
    margin-bottom: 17px;
  }
  :deep{
    .field-content{
      background-color: transparent;
    }
    .label{
      color: #68737D;
      font-weight: 600;
      //font-size: 14px;
    }
    .field-content::before{
      border: 2px dashed #e5e5e5;
    }
    .field{
      margin: 0 0 18px;
    }
  }
}
.invite-modal-buttons{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 23px;
  margin-bottom: 45px;
  &__reset{
    border: 1px solid currentColor;
  }
}
.partner-list-title{
  font-family: 'Montserrat';
  //font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  margin-bottom: 26px;
  @include mobile{
    font-size: 18px;
  }
}
</style>